import {useEffect, useState} from "react";

/**
 * Study statistics interface
 */
export interface StudyStats {
  totalSessions: number;
  currentStreak: number;
  totalStudyTimeMs: number;
  activityData: Map<string, number>; // ISO date string -> session count
}

/**
 * Hook to fetch study session statistics
 *
 * TODO: This is a placeholder implementation that returns mock data.
 * Once the study session storage layer is implemented, this should:
 * 1. Query IndexedDB for all study.session records
 * 2. Count total sessions
 * 3. Calculate streak from session dates
 * 4. Sum total study time
 * 5. Build activity map for heatmap (date -> session count)
 */
export function useStudyStats() {
  const [stats, setStats] = useState<StudyStats | null>(null);
  const [isLoading, setIsLoading] = useState(true);
  const [error, setError] = useState<Error | null>(null);

  useEffect(() => {
    const fetchStats = async () => {
      try {
        setIsLoading(true);

        // TODO: Replace with actual IndexedDB query
        // For now, return empty stats for new users
        const mockStats: StudyStats = {
          totalSessions: 0,
          currentStreak: 0,
          totalStudyTimeMs: 0,
          activityData: new Map(),
        };

        setStats(mockStats);
        setError(null);
      } catch (err) {
        setError(err instanceof Error ? err : new Error("Failed to fetch study stats"));
      } finally {
        setIsLoading(false);
      }
    };

    fetchStats();
  }, []);

  return {stats, isLoading, error};
}
